import { useIsDesktop } from "common/MediaQueries"
import { useState } from "react"
import styled from "styled-components"
import { useSwiper } from "swiper/react"

const StyledBtnContainer = styled.div<{
  $isDesktop: boolean
  $numSlides: number
}>`
  cursor: pointer;
  display: inline-block;
  position: relative;
  top: ${(p) => (p.$isDesktop ? "10px" : "-26px;")};
  z-index: 999;
  right: ${(p) => {
    const rightMargin = p.$isDesktop ? 15 : 6
    return p?.$numSlides * 9 + rightMargin
  }}px;

  border-radius: 50%;

  :hover {
    background: ${(p) => p.theme.colors.grey};
  }
`

const StyledImgContainer = styled.div<{
  $isDesktop?: boolean
}>`
  width: ${(p) => (p.$isDesktop ? "40" : "24")}px;
  height: ${(p) => (p.$isDesktop ? "40" : "24")}px;
  overflow: hidden;
`

const StyledImgWrapper = styled.div<{
  $pauseAutoplay?: boolean
  $isDesktop?: boolean
}>`
  width: ${(p) => (p.$isDesktop ? "40" : "24")}px;
  height: ${(p) => (p.$isDesktop ? "80" : "48")}px;

  background-image: ${(p) =>
    p.$isDesktop
      ? `url(/img/icons/PauseIconDesktop.svg),
url(/img/icons/PlayIconDesktop.svg)`
      : `url(/img/icons/PauseIconMobile.svg),
url(/img/icons/PlayIconMobile.svg)`};

  background-position: ${(p) =>
    p.$pauseAutoplay
      ? "bottom center, top center"
      : "top center, bottom center"};

  background-repeat: no-repeat;
`

type PauseButtonProps = {
  numSlides?: number
}

const PauseButton = ({ numSlides }: PauseButtonProps) => {
  const swiper = useSwiper()
  const [pauseAutoplay, setPauseAutoplay] = useState(false)
  const isDesktop = useIsDesktop()

  const handleChange = () => {
    if (pauseAutoplay) {
      swiper.autoplay.start()
      setPauseAutoplay(false)
      return
    }

    if (!pauseAutoplay) {
      swiper.autoplay.stop()
      setPauseAutoplay(true)
      return
    }
  }

  return (
    <StyledBtnContainer
      onKeyDown={(e) => {
        if (e.key === "Enter") handleChange()
      }}
      $isDesktop={isDesktop}
      $numSlides={numSlides}
      onClick={() => {
        handleChange()
      }}
      tabIndex={0}
      role="button"
      aria-pressed={pauseAutoplay}
      aria-label={pauseAutoplay ? "הפעלת הסליידר" : "עצירת הסליידר"}
    >
      <StyledImgContainer $isDesktop={isDesktop}>
        <StyledImgWrapper
          $isDesktop={isDesktop}
          $pauseAutoplay={pauseAutoplay}
        />
      </StyledImgContainer>
    </StyledBtnContainer>
  )
}

export default PauseButton
